/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeType } from './CodeType';
import {
    CodeTypeFromJSON,
    CodeTypeFromJSONTyped,
    CodeTypeToJSON,
    CodeTypeToJSONTyped,
} from './CodeType';

/**
 * 
 * @export
 * @interface CodeCreate
 */
export interface CodeCreate {
    /**
     * 
     * @type {string}
     * @memberof CodeCreate
     */
    name: string;
    /**
     * 
     * @type {CodeType}
     * @memberof CodeCreate
     */
    type: CodeType;
    /**
     * 
     * @type {string}
     * @memberof CodeCreate
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CodeCreate
     */
    problem_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeCreate
     */
    user_id: string;
    /**
     * 
     * @type {Date}
     * @memberof CodeCreate
     */
    created_at?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CodeCreate
     */
    is_active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CodeCreate
     */
    last_used?: Date;
    /**
     * 
     * @type {string}
     * @memberof CodeCreate
     */
    blockly_workspace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeCreate
     */
    teacher_comments?: string | null;
}



/**
 * Check if a given object implements the CodeCreate interface.
 */
export function instanceOfCodeCreate(value: object): value is CodeCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function CodeCreateFromJSON(json: any): CodeCreate {
    return CodeCreateFromJSONTyped(json, false);
}

export function CodeCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': CodeTypeFromJSON(json['type']),
        'code': json['code'],
        'problem_id': json['problem_id'] == null ? undefined : json['problem_id'],
        'user_id': json['user_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'last_used': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
        'blockly_workspace': json['blockly_workspace'] == null ? undefined : json['blockly_workspace'],
        'teacher_comments': json['teacher_comments'] == null ? undefined : json['teacher_comments'],
    };
}

export function CodeCreateToJSON(json: any): CodeCreate {
    return CodeCreateToJSONTyped(json, false);
}

export function CodeCreateToJSONTyped(value?: CodeCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': CodeTypeToJSON(value['type']),
        'code': value['code'],
        'problem_id': value['problem_id'],
        'user_id': value['user_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'is_active': value['is_active'],
        'last_used': value['last_used'] == null ? undefined : ((value['last_used']).toISOString()),
        'blockly_workspace': value['blockly_workspace'],
        'teacher_comments': value['teacher_comments'],
    };
}

